/* eslint-disable @typescript-eslint/require-await */
import { isEmpty } from 'lodash';

import {
   AppointmentAdvancePayment,
   AppointmentAdvancePaymentQuery,
} from '@dreryk/egabinet-appointment-advance-payment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { AppointmentDetails, AppointmentDetailsQuery } from '@dreryk/egabinet-appointment-frontend-api';

import { performCqrsQueryFind, performCqrsQueryGet } from '@dreryk/command-query-react-common';

import { protectFeature } from '~libs.shared.system';

export const performAppointmentAdvancePaymentCqrsFind = async (
   appointmentId: AppointmentId
): Promise<AppointmentAdvancePayment | null> => {
   return protectFeature(
      'searchingPrivateMedicalServices',
      async () =>
         performCqrsQueryFind<AppointmentAdvancePayment>(() => {
            const query = new AppointmentAdvancePaymentQuery();
            query.appointmentIds = [appointmentId];
            return query;
         }),
      () => null
   )();
};

export const performAppointmentDetailsCqrsGet = async (appointmentId: AppointmentId): Promise<AppointmentDetails> => {
   return performCqrsQueryGet<AppointmentDetails>(() => {
      const query = new AppointmentDetailsQuery();
      query.appointmentId = appointmentId;
      return query;
   });
};

export const isAdvancePaymentOverpaid = (advancePayment: AppointmentAdvancePayment): boolean =>
   advancePayment.paidAmount.asNumber() > advancePayment.requiredAmount.asNumber();

export const hasAnyReceptionServiceWithAdvancePayment = (appointmentDetails: AppointmentDetails): boolean => {
   if (isEmpty(appointmentDetails.receptionServices)) {
      return false;
   }

   return appointmentDetails.receptionServices.some(
      ({ advancePaymentValue }) => advancePaymentValue && advancePaymentValue.asNumber() > 0
   );
};
